import { SuperModel, FieldConfig } from './super-model';

export class EmbedModel extends SuperModel {
	additionalMetaData: MetadataBuilder = {};
	isReadonly: boolean;
	isHidden: boolean;
	fieldType: FieldType;
	fieldColumn: string;
	isRequired: boolean;
	fieldIcon?: FieldIcon;
	embedAction: EmbedAction = {
		type: 'icon',
		icon: 'done'
	};
	value?: FormValue;
	constructor(
		field
	) {
		super(field);
		this.additionalMetaData = field.additionalMetaData;
		if ([null, undefined].includes(this.additionalMetaData)) {
			this.additionalMetaData = {};
		}
		if (!this.additionalMetaData.hasOwnProperty('changeEventEmit')) {
			this.additionalMetaData.changeEventEmit = true;
		}
		if (!this.additionalMetaData.hasOwnProperty('showDescription')) {
			this.additionalMetaData.showDescription = true;
		}
		if (!this.additionalMetaData.hasOwnProperty('showLink')) {
			this.additionalMetaData.showLink = true;
		}
		if (!this.additionalMetaData.hasOwnProperty('showLabel')) {
			this.additionalMetaData.showLabel = true;
		}
	}
}

interface FormValue {
	link: string;
	title: string;
	image?: string;
	description?: string;
}

interface FieldIcon {
	prefix?: {
		icon?: string,
		method?: string,
		caption?: string,
		disabled?: boolean
	};
}

interface EmbedAction {
	type: 'button' | 'icon';
	caption?: string;
	icon?: string;
	tooltip?: string;
}

type FieldType = 'embed';

interface MetadataBuilder {
	fieldConfig?: FieldConfig;
	changeEventEmit?: boolean;
	showLink?: boolean;
	showDescription?: boolean;
	showLabel?: boolean;
}
